<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :model="searchForm" :inline="true" size="mini" label-width="80px">
          <el-form-item label="文件名:">
            <el-input v-model.trim="searchForm.fileName" @keyup.enter.native="onSearch"></el-input>
          </el-form-item>
          <el-form-item label="日期:">
            <form-date-range
              :form="searchForm"
              startKey="startTime"
              endKey="endTime"
              :usingTime="false"
              valueFormat="yyyyMMdd"
            ></form-date-range>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button class="green-btn" size="mini" @click="onSearch">搜索</el-button>
          <el-button class="orange-btn" size="mini" @click="reset">重置</el-button>
        </template>
      </search-box>
    </template>

    <table-panel ref="tablePanel">
      <template v-slot:header-left>
        <el-button type="primary" size="mini" @click="showExport">批量上传</el-button>
        <el-button type="text">{{ fliePath }}</el-button>
      </template>
      <el-table
        border
        stripe
        ref="tableRef"
        :header-cell-style="{ backgroundColor: '#F4F8FB', textAlign: 'center' }"
        :cell-style="{ textAlign: 'center' }"
        :data="tableData.records"
        :height="maxTableHeight"
        v-loading="loading"
      >
        <el-table-column :show-overflow-tooltip="true" prop="fileName" label="文件名" min-width="200">
          <template slot-scope="scope">
            <template v-if="scope.row.videoFlag == 'Y'">
              <el-link :underline="false" type="primary" @click="videoShow(scope.row)">{{ scope.row.fileName }}</el-link>
            </template>
            <template v-else>{{ scope.row.fileName }}</template>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="creationDate" label="上传时间" min-width="160"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="createdBy" label="上传人" min-width="100"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="fileExt" label="类型" min-width="80"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="fileSize" label="大小" min-width="100"></el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 100, 500, 1000]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="tableData.total"
          ></el-pagination>
        </div>
      </template>
    </table-panel>

    <!-- 上传弹窗 -->
    <upload-dialog
      :visible.sync="dialogFormVisible"
      :folderId="folderId"
      @success="onUploadSuccess"
    />
    <!-- 查看图片弹窗 -->
    <el-dialog title="视频查看" :visible.sync="imgFormVisible" :close-on-click-modal="false" width="50%" v-esc-close><imgShow :imgList="imgList"></imgShow></el-dialog>
  </content-panel>
</template>
<script>
import pagePathMixin from '@/utils/page-path-mixin'
import tableMixin from '@/utils/tableMixin'
import imgShow from './imgShow';
import uploadDialog from './uploadDialog.vue';

export default {
  components: {
    imgShow,
    uploadDialog,
  },
  mixins: [tableMixin, pagePathMixin],
  data() {
    return {
      loading: false,
      dialogFormVisible: false,
      searchForm: {
        fileName: '',
        startTime: '',
        endTime: '',
      },
      tableData: {
        records: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      imgList: [],
      imgFormVisible: false,
      folderId: '',
      fliePath: '',
    };
  },
  mounted() {
    this.folderId = this.$route.query.foldId;
    this.fliePath = this.$route.query.fliePath || '';
    this.init();
  },
  methods: {
    onSearch() {
      this.tableData.pageNum = 1;
      this.init();
    },
    reset() {
      this.searchForm = {
        fileName: '',
        startTime: '',
        endTime: '',
      };
      this.onSearch();
    },
    videoShow(row) {
      this.imgFormVisible = true;
      this.imgList = [];
      this.imgList.push(row.filePath);
    },
    showExport() {
      this.dialogFormVisible = true;
    },
    onUploadSuccess() {
      this.tableData.pageNum = 1;
      this.init();
    },
    init() {
      this.loading = true;
      let param = {
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
        foldId: this.folderId,
        ...this.searchForm,
      };
      this.$q.shortVideoOverview
        .videoFiles({ data: JSON.stringify(param) })
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
          } else {
            this.tableData = [];
          }
        })
        .finally((_) => {
          this.loading = false;
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init();
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init();
    },
  },
};
</script>
<style lang="stylus" scoped>
.search-box
  >>> .el-date-editor.el-input__inner, >>> .el-select, >>> .el-input
      width 240px !important
  >>> .date-range .single-date
    width 110px !important

>>> .dialog-footer .el-select, >>> .dialog-footer .el-input
  width: 300px !important

>>> .el-select__tags-text
  display: inline-block
  max-width: 60px
  overflow: hidden
  text-overflow: ellipsis
  white-space: nowrap

>>> .el-tag__close.el-icon-close
  top: 0px
  right: -4px
</style>

